export default __webpack_public_path__ + "static/media/banglore.2caf3695.svg";